import "./Styles/Footer.css";
import logo from "../assets/logo.png";

function Footer() {
  return (
    <>
      {/* FOOTER SECTION */}
      <footer className="footer">

        <div className="footer-top">

          {/* LEFT */}
          <div className="footer-logo-box">

            <div className="logo">

              <img
                  src={logo}
                  alt="logo"
                  className="footer-logo"
              />

            </div>

            <div className="footer-social">

              <a href="/">
                <i className="fa-brands fa-facebook-f"></i>
              </a>

              <a href="/">
                <i className="fa-brands fa-twitter"></i>
              </a>

              <a href="/">
                <i className="fa-brands fa-instagram"></i>
              </a>

            </div>

          </div>

          {/* SOLUTIONS */}
          <div className="footer-column">

            <h3>SOLUTIONS</h3>

            <a href="/">Property</a>
            <a href="/">Startup</a>
            <a href="/">Challan</a>
            <a href="/">Ask Lawyer</a>
            <a href="/">API Services</a>
            <a href="/">Find Lawyers in Cities</a>

            <button>
              Talk to Lawyer ❯
            </button>

          </div>

          {/* SUPPORT */}
          <div className="footer-column">

            <h3>SUPPORT</h3>

            <a href="/">
              <i className="fa-solid fa-phone"></i>
              +91-8448445049
            </a>

            <a href="/">
              <i className="fa-regular fa-envelope"></i>
              info@legalAxis.com
            </a>

            <a href="/">
              <i className="fa-brands fa-whatsapp"></i>
              WhatsApp
            </a>

          </div>

          {/* COMPANY */}
          <div className="footer-column">

            <h3>COMPANY</h3>

            <a href="/">About</a>
            <a href="/">Contact us</a>
            <a href="/">Blogs</a>
            <a href="/">Advisors</a>
            <a href="/">Careers</a>

            <button className="lawyer-btn">
              Lawyers click here
            </button>

          </div>

          {/* LEGAL */}
          <div className="footer-column">

            <h3>LEGAL</h3>

            <a href="/">Privacy Policy</a>
            <a href="/">Terms of use</a>
            <a href="/">LegalAxis Cash Terms</a>

          </div>

        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">

          <p>
            2025-26 © Calltech Global
            <span> | All Rights Reserved</span>
          </p>

        </div>

      </footer>
    </>
  );
}

export default Footer;